import React,{useState} from "react";
import {Switch} from "@headlessui/react"

const SwitchComponent = (props)=>{
    const [Enabled, setEnabled] = useState(props.enabled??false);
    
    const onChange = (value)=>{
        setEnabled(value);
        props.function();
    }
    return (
        <div>
            <Switch
                checked={Enabled}
                onChange={onChange}
                className={`${
                    Enabled ? props.bg_active??'bg-gray-600' : props.bg_inactive??'bg-gray-200'
                    } relative inline-flex h-3 w-10 items-center rounded-full`}
                >
                <span className="sr-only">{props.name}</span>
                <span
                    aria-hidden="true"
                    className={`${Enabled ? 'translate-x-5' : 'translate-x-0'}
                    pointer-events-none inline-block h-5 w-5 transform rounded-full bg-gray-300 bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                    />
            </Switch>
        </div>
    )
}

export default SwitchComponent